import axios from "axios";
export default (message: string, channel: string = "bugs") => {
  try {
    axios.post(`${process.env.REACT_APP_DISCORD_BASE_URL}/send-message`, { message, channel });
  } catch (e) {
    process.env.DEV_MODE && console.log("🚨 Error caught", e);
  }
};
